<template>
  <div class="complete-info">
    <el-form ref="authorForm" :rules="authorFormRules" :model="authorForm" size="small" label-width="140px">
      <el-form-item label="类型">
        <el-radio>{{ authorForm.authorType == 1 ? '个人' : '公司' }}</el-radio>
      </el-form-item>
      <el-form-item label="分成比例">
        <el-input v-model="authorForm.percentage" :readonly="true" maxlength="30">
          <template slot="append"
            >%</template
          >
        </el-input>
      </el-form-item>
      <el-form-item label="创作者介绍" prop="remark">
        <el-input type="textarea" :rows="5" style="width: 250px!important;" maxlength="100" placeholder="例:职业画家、当代青年艺术家 ，毕业于中国美术学院" show-word-limit v-model="authorForm.remark"> </el-input>
      </el-form-item>
      <!-- <el-form-item label="">
        （含授权范围、二改禁忌、推广要求）
      </el-form-item> -->
      <el-form-item label="作者照片" prop="authorPic">
        <MyUpload info="仅支持jpep、png, 小于20M" :imgKey.sync="authorForm.authorPic" :url="authorForm.authorPicUrl" />
      </el-form-item>
      <el-form-item label="创作者文档介绍" prop="vedioSource">
        <MyUpload :on-preview="downloadFile" info="仅支持pdf, 小于20M" accept="application/pdf" list-type="text" :imgKey.sync="authorForm.vedioSource" :url="authorForm.vedioSourceUrl" />
      </el-form-item>
    </el-form>
    <div class="btn-group">
      <el-button style="margin-left: 120px;" @click="$router.back()">取消</el-button>
      <el-button type="primary" @click="updateConfirm">确定</el-button>
    </div>
  </div>
</template>

<script>
import API, { baseUrl } from '../lib/API'
import MyUpload from '../components/common/MyUpload'
export default {
  name: 'SupplyInfo',
  components: {
    MyUpload
  },
  data() {
    return {
      authorFormRules: {
        vedioSource: [{ required: true, message: '请上传文档介绍', trigger: 'blur' }],
        authorPic: [{ required: true, message: '请上传作者照片', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入生产者介绍', trigger: 'blur' }]
      },
      authorForm: {
        percentage: '',
        authorType: '',
        remark: '',
        authorPic: '',
        authorPicUrl: '',
        vedioSource: '',
        vedioSourceUrl: ''
      }
      // authorFormRules: {
      //   personName: [{ required: true, message: '请输入生产者姓名', trigger: 'blur' }],
      //   personPhone: [{ required: true, message: '请输入正确的手机号码', trigger: 'blur' }, { min: 11, max: 11, message: '请输入正确的手机号码', trigger: 'blur' }],
      //   idCardKey: [{ required: true, message: '请上传手持身份证照片', trigger: 'blur' }]
      // }
    }
  },
  created() {
    this.authorId = localStorage.getItem('authorId')
    this.getAuthorInfo()
  },
  methods: {
    downloadFile() {
      this.download(this.authorForm.vedioSource)
    },
    download(designPdf) {
      let a = document.createElement('a')
      a.href = `${baseUrl}/download/image?key=${designPdf}&accesstoken=${localStorage.getItem('token')}`
      a.click()
    },
    getAuthorInfo() {
      new API(this).POST({
        url: `/author/getAuthorDetail?authorId=${this.authorId}`,
        cb: res => {
          Object.assign(this.authorForm, res)
        }
      })
    },
    updateConfirm() {
      this.$refs.authorForm
        .validate()
        .then(() => {
          this.$confirm('变更个人信息后，系统需要重新审核。是否变更?', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.update()
            localStorage.setItem('checkStatus', 0)
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    update() {
      new API(this).POST({
        url: '/author/updateAuthor',
        params: this.authorForm,
        cb: res => {
          this.$notify({
            title: '更新成功',
            type: 'success'
          })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.complete-info {
  width: 400px;
  margin: 0 auto;
}
.btn-group {
  display: flex;
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/SupplyInfo.vue